import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { actions } from "@/store/store.js";

const useCurrentAccount = () => {
    const dispatch = useDispatch();
    const { currentAccount, currentAccountLoading } = useSelector((state) => state.accounts);

    useEffect(() => {
        if (!currentAccount && !currentAccountLoading) {
            dispatch(actions.accounts.loadCurrentAccount());
        }
    }, []);

    return { currentAccount, currentAccountLoading };
};

export default useCurrentAccount;
